import { api } from '../../../../../lib/api';
import { snakeCaseKeys } from '../../../../../shared/helpers';

export const createPost = values => {
  const { campaignId, ...params } = values;
  const postData = snakeCaseKeys(params);

  return api({
    method: 'post',
    url: `/api/client_admin/campaigns/${campaignId}/posts/`,
    data: { post: postData },
  });
};

export const updatePost = values => {
  const { campaignId, ...params } = values;
  const postData = snakeCaseKeys(params);

  return api({
    method: 'put',
    url: `/api/client_admin/campaigns/${campaignId}/posts/${params.id}`,
    data: { post: postData },
  });
};

export const deletePost = values => {
  const { campaignId, postId } = values;

  return api({
    method: 'delete',
    url: `/api/client_admin/campaigns/${campaignId}/posts/${postId}`,
  });
};

export const revertPost = values => {
  const { campaignId, ...params } = values;
  const postData = snakeCaseKeys(params);

  return api({
    method: 'put',
    url: `/api/client_admin/campaigns/${campaignId}/posts/${params.id}/revert`,
    data: { post: postData },
  });
};

export const updateMessage = values => {
  const { campaignId, postId, ...params } = values;
  const messageData = snakeCaseKeys(params);

  return api({
    method: 'put',
    url: `/api/client_admin/campaigns/${campaignId}/posts/${postId}/messages/${params.id}`,
    data: { message: messageData },
  });
};

export const createMessage = values => {
  const { campaignId, postId, ...params } = values;
  const messageData = snakeCaseKeys(params);

  return api({
    method: 'post',
    url: `/api/client_admin/campaigns/${campaignId}/posts/${postId}/messages`,
    data: { message: messageData },
  });
};

export const sendTest = values => {
  const { campaignId, postId, ...params } = values;
  const messageData = snakeCaseKeys(params.message);

  return api({
    method: 'post',
    url: `/api/client_admin/campaigns/${campaignId}/posts/${postId}/messages/${messageData.id}/send_test?email_template=${params.template}`,
    data: { message: messageData },
  });
};

export const deleteMessage = values => {
  const { campaignId, postId, messageId } = values;

  api({
    method: 'delete',
    url: `/api/client_admin/campaigns/${campaignId}/posts/${postId}/messages/${messageId}`,
  });
};
